import { useForm } from "@tanstack/react-form";

import {
  EvaluationUpdateFormProps,
  UpdateEvaluationOverride,
} from "./EvaluationUpdateForm.decl";
import { transformFormValueIntoInput } from "./EvaluationUpdateForm.utility";

type UseEvaluationUpdateFormParams = EvaluationUpdateFormProps & {
  onSubmit: (input: ReturnType<typeof transformFormValueIntoInput>) => void;
};

/**
 * Wraps `useForm` for the update-evaluation form so the form-API type is
 * inferred straight from the hook (`ReturnType<typeof useEvaluationUpdateForm>`)
 * rather than by hand-spelling react-form v1's 12 (now-undefaulted) generics.
 * This is the idiomatic TanStack Form v1 pattern — see the "Form Composition"
 * guide.
 */
export function useEvaluationUpdateForm({
  evaluation,
  revieweeUserId,
  onSubmit,
}: UseEvaluationUpdateFormParams) {
  return useForm({
    defaultValues: {
      categories: evaluation.categories,
      feedback: evaluation.feedback ?? "",
      // Below are hidden fields.
      revieweeUserId,
      ID: evaluation.ID,
    } as UpdateEvaluationOverride,
    onSubmit: async ({ value }) => {
      onSubmit(transformFormValueIntoInput(value));
    },
  });
}

export type EvaluationUpdateFormApi = ReturnType<
  typeof useEvaluationUpdateForm
>;
